import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CloseCircleOutlined, EyeOutlined, WarningOutlined } from '@ant-design/icons';
// import { Col, Row, Modal, Table, DatePicker, Select, Card, Tabs } from 'antd';
import { Col, Row, Modal, Table, Card } from 'antd';
import moment from 'moment';
import { Text, Box } from 'atoms';
import { DAY_DATE_FORMAT } from 'utils';
import { getContractExpire } from 'store/commonSlice';
import { showLoader } from 'store/appSlice';
import { ACL } from 'components/common';

const MessageWrap = styled(Card)`
	font-size: 16px;
	border-radius: 4px;
	margin-bottom: 16px;
	> .ant-card-body {
		padding: 10px 16px;
		:before {
			height: calc(100% - 22px);
			background: #6e57f9;
			width: 2px;
			border-radius: 2px;
			position: absolute;
			left: -1px;
			top: 12px;
		}
	}
`;

const ContainerModal = styled(Box)`
	padding: 20px 0;
`;

const BoxText = styled(Box)`
	font-size: 15px;
	font-weight: 500;
`;

const ViewDetails = styled(Col)`
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		color: red;
	}
`;

function VendorContract() {
	const dispatch = useDispatch();
	const [rowVendorData, setVendorRowData] = useState({});
	const [openVendorModal, setVendorModal] = useState(false);
	const [totalVendorDataCount, setTotalVendorDataCount] = useState(0);

	useEffect(() => {
		dispatch(
			getContractExpire({
				search_type: 'vendor_contract',
			})
		).then((res) => {
			// console.log(res);
			setVendorRowData(res?.data);
			setTotalVendorDataCount(res?.meta?.count);
		});
	}, []);

	const handleVendorChange = (pagination) => {
		dispatch(showLoader());
		const offset = pagination.current * pagination.pageSize - pagination.pageSize;
		dispatch(
			getContractExpire({
				search_type: 'vendor_contract',
				offset,
				limit: pagination.pageSize,
			})
		).then((res) => {
			// console.log(res);
			setVendorRowData(res?.data);
			setTotalVendorDataCount(res?.meta?.count);
		});
	};

	const VendorContractsTableConfig = [
		{
			title: ' ',
			dataIndex: 'already_expired',
			key: 'already_expired',
			hidden: false,
			width: 30,
			render: (already_expired) => (
				<Box>
					<Box>
						{already_expired === true && (
							<CloseCircleOutlined
								style={{
									color: 'red',
									fontSize: '14px',
								}}
							/>
						)}
					</Box>
					<Box>
						{already_expired === false && (
							<WarningOutlined
								style={{
									color: 'orange',
									fontSize: '14px',
								}}
							/>
						)}
					</Box>
				</Box>
			),
		},
		{
			title: 'Vendor Name',
			dataIndex: 'vendor_name',
			key: 'vendor_name',
			hidden: false,
			render: (vendor_name) => <Text overFlow="hidden">{vendor_name || ''}</Text>,
		},
		{
			title: 'Project Location code',
			dataIndex: 'project_location_code',
			key: 'project_location_code',
			hidden: false,
			width: 120,
			render: (project_location_code) => (
				<Text overFlow="hidden">{project_location_code || ''}</Text>
			),
		},
		{
			title: 'Client Name',
			dataIndex: 'client_name',
			key: 'client_name',
			hidden: false,
			width: 120,
			render: (client_name) => <Text overFlow="hidden">{client_name || ''}</Text>,
		},
		{
			title: 'Vehicle Type',
			dataIndex: 'vehicle_type',
			key: 'vehicle_type',
			hidden: false,
			width: 120,
			render: (vehicle_type) => <Text overFlow="hidden">{vehicle_type || ''}</Text>,
		},
		{
			title: 'City',
			dataIndex: 'city',
			key: 'city',
			hidden: false,
			width: 100,
			render: (city) => <Text overFlow="hidden">{city || ''}</Text>,
		},
		{
			title: 'Contract Date',
			dataIndex: 'contract_date',
			key: 'contract_date',
			hidden: false,
			width: 120,
			render: (contract_date) => (
				<Text overFlow="hidden">{moment(contract_date).format(DAY_DATE_FORMAT) || ''}</Text>
			),
		},
		{
			title: 'Expiry Date',
			dataIndex: 'expiry_date',
			key: 'expiry_date',
			width: 110,
			hidden: false,
			render: (expiry_date) => (
				<Text overFlow="hidden">{moment(expiry_date).format(DAY_DATE_FORMAT) || ''}</Text>
			),
		},
		{
			title: 'View',
			dataIndex: 'id',
			key: 'id',
			hidden: false,
			width: 70,
			render: (id) => (
				<ACL action="update" module="vendor_contract">
					<Link to={`/vendor-contracts/${id}`}>
						<EyeOutlined />
					</Link>
				</ACL>
			),
		},
	];

	return (
		<>
			{totalVendorDataCount?.total > 0 && (
				<MessageWrap>
					<Row justify="space-between">
						<Col>
							<WarningOutlined
								style={{
									color: '#6e57f9',
									marginRight: '8px',
								}}
							/>
							<span
								style={{
									color: '#6e57f9',
								}}
							>
								Vendor Contract Expiry :
							</span>
							<span
								style={{
									color: 'red',
									margin: '0 16px',
								}}
							>
								{`It Looks like ${totalVendorDataCount?.already_expired} contract are Expired.`}
							</span>
							<span style={{ marginRight: '16px' }}>|</span>
							{`and ${totalVendorDataCount?.about_to_expire} contract is going to expire in few days`}
						</Col>

						<ViewDetails onClick={() => setVendorModal(true)}>View Details</ViewDetails>
					</Row>
				</MessageWrap>
			)}

			<Modal
				title="Vendor Contract Expiry List"
				style={{
					top: 20,
				}}
				open={openVendorModal}
				onOk={() => setVendorModal(false)}
				onCancel={() => setVendorModal(false)}
				width={1000}
				height={500}
			>
				<Box>
					<Row justify="space-between">
						<Col>
							<BoxText>
								{' '}
								<CloseCircleOutlined
									style={{
										color: 'red',
										fontSize: '14px',
									}}
								/>{' '}
								&nbsp; Expired: {totalVendorDataCount?.already_expired}
								<span> &nbsp; &nbsp;</span>
								<WarningOutlined
									style={{
										color: 'orange',
										fontSize: '14px',
									}}
								/>
								&nbsp; About to Expire: {totalVendorDataCount?.about_to_expire}
							</BoxText>
						</Col>
						<Col></Col>
					</Row>
				</Box>
				<ContainerModal>
					{totalVendorDataCount?.total > 0 && (
						<Table
							rowKey={(rowItem) => rowItem.id}
							columns={VendorContractsTableConfig}
							dataSource={rowVendorData}
							onChange={handleVendorChange}
							scroll={{ y: 540 }}
							pagination={{
								total: totalVendorDataCount?.total,
							}}
						/>
					)}
				</ContainerModal>
			</Modal>
		</>
	);
}

export default VendorContract;
